// src/hooks/announcements/useAnnouncementAttachments.js
import { useCallback } from "react";

export default function useAnnouncementAttachments({
  announcementId,
  selectedCompanyId,
  emptyDraft,
  draftRef,
  setMany,
  uploadAttachments,
  deleteAttachment,
  showToast,
}) {
  const handleUploadFiles = useCallback(
    async (files) => {
      if (!files || files.length === 0) return;
      if (!announcementId) {
        showToast?.("Lisää liitteet tallennuksen jälkeen", "error", 2200);
        return;
      }
      if (!selectedCompanyId) return;
      try {
        const uploaded = await uploadAttachments(
          selectedCompanyId,
          announcementId,
          files
        );
        const prev = draftRef.current || emptyDraft;
        setMany({
          ...prev,
          attachments: [...(prev.attachments || []), ...(uploaded || [])],
        });
        showToast?.("Liitteet lisätty", "success", 1600);
      } catch (e) {
        console.error("Attachment upload failed:", e);
        showToast?.("Liitteen lisääminen epäonnistui", "error", 2500);
      }
    },
    [
      announcementId,
      selectedCompanyId,
      uploadAttachments,
      draftRef,
      emptyDraft,
      setMany,
      showToast,
    ]
  );

  const handleDeleteAttachment = useCallback(
    async (attachmentId) => {
      if (!announcementId || !attachmentId) return;
      if (!selectedCompanyId) return;
      try {
        await deleteAttachment(selectedCompanyId, announcementId, attachmentId);
        const prev = draftRef.current || emptyDraft;
        setMany({
          ...prev,
          attachments: (prev.attachments || []).filter(
            (a) => a.id !== attachmentId
          ),
        });
        showToast?.("Liite poistettu", "success", 1600);
      } catch (e) {
        console.error("Attachment delete failed:", e);
        showToast?.("Liitteen poisto epäonnistui", "error", 2500);
      }
    },
    [
      announcementId,
      selectedCompanyId,
      deleteAttachment,
      draftRef,
      emptyDraft,
      setMany,
      showToast,
    ]
  );
  return {
    handleUploadFiles,
    handleDeleteAttachment,
  };
}